module.exports = __webpack_public_path__ + "static/media/Swot-White.2012718a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/light-nav-images/Swot-White.svg
// module id = 572
// module chunks = 0